import React from "react";
import CancelButton from "@components/FlowActionButtons/CancelButton";
import type { Task } from "@services/vesselCall/types";
import { canUserCancel } from "../utils";

interface CancelVesselCallProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
    hasMovementAnchorTimeOrAllFast?: boolean;
    movementStatus?: string;
    roles?: string[];
  };
  openDrawer: (drawerName: string) => void;
  refetchVesselCall: () => void;
}
const LANG_BASE = "vessel-call.vessel-call-status-header";

const CancelVesselCall: React.FC<CancelVesselCallProps> = ({ vesselCallFlowData, openDrawer }) => {
  if (!vesselCallFlowData) {
    return null;
  }

  const isActionAvailable = canUserCancel(
    vesselCallFlowData.status,
    vesselCallFlowData.hasMovementAnchorTimeOrAllFast ?? false,
    vesselCallFlowData.movementStatus,
    vesselCallFlowData.roles,
  );

  const handleCancelClick = () => {
    openDrawer("cancelDrawer");
  };

  return (
    <CancelButton
      langBase={LANG_BASE}
      permission="canCancelVesselCall"
      isActionAvailable={isActionAvailable}
      onCancel={handleCancelClick}
    />
  );
};
export default CancelVesselCall;
